import React from 'react';
import { Helmet } from 'react-helmet';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import HeroSection from './components/HeroSection';
import PartnershipShowcase from './components/PartnershipShowcase';
import ResourceNetwork from './components/ResourceNetwork';
import CTASection from './components/CTASection';

const PartnersResourcesHub = () => {
  return (
    <>
      <Helmet>
        <title>Partenaires & Ressources | CRF PERFECTION - Réseau d'Excellence</title>
        <meta 
          name="description" 
          content="Découvrez notre réseau de partenaires stratégiques et ressources d'hébergement qui renforcent notre capacité à offrir des services d'excellence dans l'automobile." 
        />
        <meta name="keywords" content="partenaires stratégiques, ressources hébergement, alliances professionnelles, réseau excellence automobile, services partenaires" />
        <meta property="og:title" content="Partenaires & Ressources | CRF PERFECTION" />
        <meta 
          property="og:description" 
          content="Un réseau d'alliances stratégiques et de ressources qui amplifient notre excellence en services automobiles." 
        />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        <Header />
        
        <main className="relative">
          <HeroSection />
          <PartnershipShowcase />
          <ResourceNetwork />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default PartnersResourcesHub;